"use strict";

import { animate, inView, ScrollOffset, scroll } from "motion";
import { get_type, maybe } from "./lib.js";

const animate_if_preferred = (elements, keyframes, options = undefined) =>
	window.matchMedia("(prefers-reduced-motion: reduce)").matches
		? (() => {
				const new_options = structuredClone(options ?? {});
				for (const key in new_options) {
					if (Object.hasOwnProperty.call(new_options, key)) {
						const element = new_options[key];
						if (get_type(element) === "Object") {
							new_options[key].duration = 0;
							new_options[key].easing = "linear";
						}
					}
				}
				new_options.duration = 0;
				new_options.easing = "linear";
				return animate(elements, keyframes, new_options);
			})()
		: animate(elements, keyframes, options);

export const initialise_animations = (attribute) => {
	const go = async (element) => {
		const animation_parameters = JSON.parse(element?.dataset?.[`${attribute}`]);
		if (Array.isArray(animation_parameters)) {
			new Map(animation_parameters).forEach((v, k, m) => {
				if (v?.keyframes) {
					switch (k) {
						case "in_view":
							inView(
								element,
								() => v?.once
									? animate_if_preferred(element, v.keyframes, v?.options)
									: animate_if_preferred(element, v.keyframes, v?.options).stop,
							);
							break;
						case "scroll":
							scroll(
								animate_if_preferred(element, v.keyframes, v?.options),
								maybe(undefined)((scroll_options) =>
									typeof scroll_options?.offset === "string"
										? (() => {
												switch (scroll_options.offset.toLowerCase()) {
													case "all":
														scroll_options.offset = ScrollOffset.All;
														break;
													case "any":
														scroll_options.offset = ScrollOffset.Any;
														break;
													case "enter":
														scroll_options.offset = ScrollOffset.Enter;
														break;
													case "exit":
														scroll_options.offset = ScrollOffset.Exit;
														break;
												}
												return scroll_options;
											})()
										: scroll_options,
								)(
									v?.scroll_options?.target
										? v?.scroll_options
										: (() => {
												v.scroll_options.target = element;
												return v.scroll_options;
											})(),
								),
							);
							break;
						case "ancestor_matches":
							const [ancestor, matches] = [v?.ancestor, v?.matches];
							if (ancestor && matches) {
								const ancestor_element = element.closest(ancestor);
								if (ancestor_element) {
									new MutationObserver((mutations) =>
										mutations.forEach(() => {
											if (ancestor_element.matches(matches)) {
												animate_if_preferred(element, v.keyframes, v?.options);
											}
										}),
									).observe(ancestor_element, { attributes: true });
								}
							}
							break;
					}
				}
			});
		}
	};
	new MutationObserver((mutations) =>
		mutations.forEach((mutation) => {
			if (mutation.type === "childList") {
				mutation.addedNodes.forEach(async (node) => {
					if (node.nodeType === 1 && node.hasAttribute(`data-${attribute}`)) {
						await go(node);
					}
				});
			}
		}),
	).observe(document.body, { childList: true, subtree: true });
	document.querySelectorAll(`*[data-${attribute}]`).forEach(go);
};
